import React from "react";
import { Avatar, IconButton, Stack, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

const AccountMenuButton = ({ label, avatarImage, isDropdown, onClick }) => {
  return (
    <IconButton onClick={onClick}>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Typography>{label}</Typography>
        <Avatar
          sx={{
            width: 30,
            height: 30,
          }}
        >
          {avatarImage}
        </Avatar>
        {isDropdown && <ExpandMore style={{ margin: 0 }} />}
      </Stack>
    </IconButton>
  );
};

export default AccountMenuButton;
